import xiaoXi from './xiaoXi.vue';
export default xiaoXi;
